import { Button } from 'react-bootstrap';

export default class LogFetcher extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().subtract(1, 'day'),
      endDate: moment()
    };
  }

  startDatePicked(date) {
    this.setState({
      startDate: date
    });
  }

  endDatePicked(date) {
    this.setState({
      startDate: date
    });
  }

  onClick() {

  }

  render() {
    return (
      <div>
      </div>
    );
  }
}
